module.exports = __webpack_public_path__ + "static/media/Kiosk_Slanted.bb305d05.png";